import React from 'react';
import styled from 'styled-components';

const SuccessCard = ({ onClose }) => {
  return (
    <StyledWrapper>
      <div className="success">
        <div className="success__icon">
          <svg fill="green" height={24} viewBox="0 0 24 24" width={24}>
            <circle cx="12" cy="12" r="10" stroke="green" strokeWidth="2" fill="none" />
            <path d="M8 12l2 2 4-4" stroke="green" strokeWidth="2" fill="none" />
          </svg>
        </div>
        <div className="success__title">Successfully Added!</div>
        <div
          className="success__close"
          onClick={onClose}
          role="button"
          aria-label="Close success message"
        >
          ×
        </div>
      </div>
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  .success {
    background: #edfbd8;
    padding: 12px 14px;
    display: flex;
    align-items: center;
    border-radius: 8px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
    min-width: 250px;
    max-width: 400px;
    margin: 10px auto;
  }

  .success__icon svg {
    margin-right: 12px;
    fill: green;
  }

  .success__title {
    flex-grow: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: 500;
    font-size: 14px;
    color: rgb(34, 100, 19);
  }

  .success__close {
    margin-left: auto;
    cursor: pointer;
    font-weight: bold;
    color: rgb(34, 100, 19);
    font-size: 16px;
    padding: 0 8px;
    transition: color 0.2s ease;

    &:hover {
      color: #ff0000;
    }
  }
`;

export default SuccessCard;